import { Component, Children } from 'react';
import lodash from 'lodash';

import styles from './ComplionToolbar.scss';
import ComplionToolbarGroup from './ComplionToolbarGroup';
import ComplionToolbarDivider from './ComplionToolbarDivider';

class ComplionToolbar extends Component {
    groupChildren() {
        const { children } = this.props;
        return lodash.chain(Children.toArray(children))
            .groupBy(child => child.props.group || 'none')
            .flatMap((groupedChildren, group) => {
                return [
                    <ComplionToolbarGroup key={group} children={groupedChildren}/>,
                    <ComplionToolbarDivider key={`${group}-divider`} />
                ];
            })
            .initial()
            .value();
    }

    render() {
        return (
            <div className={styles.complionToolbar} data-cy="ComplionToolbar">
                { this.groupChildren() }
            </div>
        );
    }
}

export default ComplionToolbar;